export default {
  CHANGE: "CHANGE",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  FETCH_EVENTS: "FETCH_EVENTS",
  FETCH_GROUPS: "FETCH_GROUPS"
};
